import React, { useState } from "react";
import { mediaData } from "../data/mediaData";
import { motion } from "framer-motion";
import { FEEDBACK_STARS, storyChangeAnim } from "../data/common";

const FeedbackWrapper = ({
  setShowFeedbackScreen,
  currStoryId,
  callGaHandler,
  setShowEndScreen,
  isMobile,
  idea,
}) => {
  const [feedbackStars, setFeedbackStars] = useState(0);
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(false);
  const [suggestionContent, setSuggestionContent] = useState("");
  const [suggestionOption, setSuggestionOption] = useState("");

  const feedbackSuggestions = [
    "Improve video quality",
    "Provide personalized content",
    "Fix loading issues",
    "Something else",
  ];

  const handleSuggestionChange = (event) => {
    setSuggestionContent(event.target.value);
  };

  const handleSuggestionSubmit = (event) => {
    event.preventDefault(); // Prevent form submission (if used within a form)
    callGaHandler("Wrote_suggestion", suggestionContent);
    const timer = setTimeout(() => {
      setShowFeedbackScreen(() => false);
      clearTimeout(timer);
      setShowEndScreen(() => true);
    }, 2000);
  };

  const closeFeedback = () => {
    const closeFeedbackCount = Number(
      localStorage.getItem("close_feedback_count") || 0
    );
    localStorage.setItem("close_feedback", "true");
    localStorage.setItem("close_feedback_count", closeFeedbackCount + 1);
    setShowFeedbackScreen(() => false);
    if (feedbackStars === 1 && idea === 0) {
      if (suggestionOption) {
        callGaHandler("Suggestion_field", "Suggestion_close");
      } else {
        callGaHandler("Low_rating_feedback_form", "Low_close");
      }
    } else {
      callGaHandler("Feedback_screen", "close");
    }
  };

  const onFeedbackClick = (value) => {
    setFeedbackStars(() => value);
    setIsFeedbackSubmitted(() => true);

    callGaHandler("Journey_feedback", value);
    localStorage.setItem("feedback_value", value);
    localStorage.setItem("feedback_submitted", "true");

    if (value === 1 && idea === 0) {
      callGaHandler("Low_rating_feedback_form", "Low_open");
    } else if (idea === 1) {
      const timer = setTimeout(() => {
        setShowFeedbackScreen(() => false);
        clearTimeout(timer);
      }, 2000);
    } else {
      const timer = setTimeout(() => {
        setShowFeedbackScreen(() => false);
        clearTimeout(timer);
        setShowEndScreen(() => true);
      }, 2000);
    }
  };

  const suggestionClick = (value) => {
    setSuggestionOption(value);
    callGaHandler("Suggestion_given", value);
    if (value !== "Something else") {
      const timer = setTimeout(() => {
        setShowFeedbackScreen(() => false);
        clearTimeout(timer);
        setShowEndScreen(() => true);
      }, 2000);
    }
  };

  return (
    <motion.div
      key={currStoryId}
      className="main-swiper-wrapper main-swiper-wrapper-splash splash-wrapper-last"
      variants={storyChangeAnim}
      initial="initial"
      animate="active"
      exit="exit"
    >
      {/* close icon on set 0 */}
      {idea === 0 && (
        <div className="cross-icon">
          <img
            src={mediaData["crossIcon"]}
            alt="cross-icon"
            onClick={closeFeedback}
          />
        </div>
      )}
      {/* close icon on set 0*/}
      {/* skip text on set 1*/}
      {idea === 1 && (
        <div className="cross-icon" onClick={closeFeedback}>
          <span>SKIP</span>
        </div>
      )}
      {/* skip text on set 1*/}

      <div className="feedback-img-block">
        <img src={mediaData["feedbackBg"]} alt="feedback" className="h-full" />
        {/* feedback rating set 0*/}
        {idea === 0 && feedbackStars === 0 && (
          <div
            className={`feedback-img-block-inner ${
              !isMobile ? "feedback-img-block-inner-relative" : ""
            }`}
          >
            <h2>Thank you!</h2>
            <h5>Please rate your experience below</h5>
            <div className="rating-block">
              <ul>
                {Array.from({ length: FEEDBACK_STARS }, (_, idx) => (
                  <li key={idx}>
                    <img
                      src={
                        idx + 1 <= feedbackStars
                          ? mediaData["starRatingFill"]
                          : mediaData["starRatingBorder"]
                      }
                      alt="rating-star"
                      onClick={
                        !isFeedbackSubmitted
                          ? () => onFeedbackClick(idx + 1)
                          : null
                      }
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {/* feedback rating set 0*/}

        {/* feedback radio form  set 0*/}
        {idea === 0 && feedbackStars === 1 && (
          <div className="feedback-img-block-inner">
            <div className="one3d-radio-listing one3d-radio-button-2">
              <h3 className="one3d-radio-button-title">
                What could we have done better?
              </h3>
              <ul>
                {feedbackSuggestions.map((item, index) => (
                  <li>
                    <input
                      id={`point${index}`}
                      type="radio"
                      name="feedbackPoint"
                      value={item}
                      onClick={() => suggestionClick(item)}
                    />
                    <label htmlFor={`point${index}`}>
                      <span>{item}</span>
                    </label>
                  </li>
                ))}
              </ul>

              {suggestionOption === "Something else" && (
                <div>
                  <div className="one3d-input-textarea-w">
                    <textarea
                      id="suggestion_text"
                      placeholder="Please type your suggestion here..."
                      className="one3d-input-textarea"
                      value={suggestionContent}
                      onChange={handleSuggestionChange}
                    ></textarea>
                  </div>
                  <div className="one3d-input-textarea-w one3d-submit-button-inner">
                    <button
                      className="one3d-submit-button"
                      onClick={handleSuggestionSubmit}
                      disabled={suggestionContent.length < 10}
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {/* feedback radio form set 0*/}

        {/* feedback rating set 1*/}
        {idea === 1 && (
          <div
            className={`feedback-img-block-inner ${
              !isMobile ? "feedback-img-block-inner-relative" : ""
            }`}
          >
            <h2>How’s it going?</h2>
            <h5>Rate your experience so far!</h5>
            <div className="rating-block">
              <ul>
                {Array.from({ length: FEEDBACK_STARS }, (_, idx) => (
                  <li key={idx}>
                    <img
                      src={
                        idx + 1 <= feedbackStars
                          ? mediaData["starRatingFill"]
                          : mediaData["starRatingBorder"]
                      }
                      alt="rating-star"
                      onClick={
                        !isFeedbackSubmitted
                          ? () => onFeedbackClick(idx + 1)
                          : null
                      }
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {/* feedback rating set 1*/}

        {/* timer set 1*/}
        {/* {idea === 1 && (<div className="one3d-timer-inner">
          <div className="one3d-timer-inner-w">
            <span
              style={{
                width: "23%",
              }}
            ></span>
          </div>
        </div>
        )} */}
        {/* timer set 1 */}
      </div>
    </motion.div>
  );
};

export default FeedbackWrapper;
